/** Часть заметки: задаёт AAD шифра, чтобы шифротекст одной части нельзя было подставить в другую */
export enum EnumNotePart {
  TITLE = 'title',
  CONTENT = 'content',
}
